import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";

const UF_LIST = ["AC","AL","AP","AM","BA","CE","DF","ES","GO","MA","MT","MS","MG","PA","PB","PR","PE","PI","RJ","RN","RS","RO","RR","SC","SP","SE","TO"];

export default function BrazilMapEditor() {
  const [cfg, setCfg] = useState({ title: "Onde já estivemos no Brasil", subtitle: "Mais de 300 lançamentos em 17 estados.", states: {} });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/content/kv/brazil_states_map").then(({ data }) => {
      if (data) setCfg({ title: "Onde já estivemos no Brasil", subtitle: "Mais de 300 lançamentos em 17 estados.", states: {}, ...data });
    }).catch(() => {});
  }, []);

  const updState = (uf, patch) => setCfg((s) => ({ ...s, states: { ...s.states, [uf]: { ...(s.states?.[uf] || {}), ...patch } } }));

  const save = async () => {
    setBusy(true);
    try {
      await api.put("/content/kv/brazil_states_map", { value: cfg });
      toast.success("Mapa salvo.");
    } catch { toast.error("Erro ao salvar."); }
    finally { setBusy(false); }
  };

  return (
    <div>
      <div className="flex justify-between items-end mb-6 gap-3 flex-wrap">
        <div>
          <h1 className="font-display text-4xl">Mapa do Brasil (radar dots)</h1>
          <p className="text-sm text-neutral-500 mt-1 max-w-2xl">Os números dos estados agora vêm automaticamente do "Histórico de projetos" (calculado pela UF da coluna Cidade). Aqui você pode ativar estados manualmente (mesmo sem projeto ainda) e personalizar cores.</p>
        </div>
        <button onClick={save} disabled={busy} data-testid="brazilmap-save" className="bg-black text-white text-sm px-5 py-2.5 rounded-full hover:bg-accent-orange disabled:opacity-50"><Save className="w-3 h-3 inline mr-1" /> Salvar</button>
      </div>

      <section className="border border-black/10 rounded-md p-5 mb-6">
        <div className="grid md:grid-cols-2 gap-3">
          <div><label className="text-xs text-neutral-500">Título da seção</label><input value={cfg.title} onChange={(e) => setCfg({ ...cfg, title: e.target.value })} className="w-full border border-black/15 px-3 py-2 rounded text-sm" /></div>
          <div><label className="text-xs text-neutral-500">Subtítulo</label><input value={cfg.subtitle} onChange={(e) => setCfg({ ...cfg, subtitle: e.target.value })} className="w-full border border-black/15 px-3 py-2 rounded text-sm" /></div>
        </div>
      </section>

      <div className="border border-black/10 rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-black text-white text-xs uppercase tracking-wider">
            <tr><th className="p-3 text-left">UF</th><th className="p-3 text-left">Ativo</th><th className="p-3 text-left">Nº de Projetos</th><th className="p-3 text-left">Cor do dot</th></tr>
          </thead>
          <tbody>
            {UF_LIST.map((uf) => {
              const st = cfg.states?.[uf] || {};
              return (
                <tr key={uf} className="border-t border-black/5">
                  <td className="p-3 font-mono">{uf}</td>
                  <td className="p-3"><input type="checkbox" checked={!!st.active} onChange={(e) => updState(uf, { active: e.target.checked })} data-testid={`bm-active-${uf}`} /></td>
                  <td className="p-3"><input type="number" min={0} value={st.count ?? 0} onChange={(e) => updState(uf, { count: Number(e.target.value) })} className="w-20 border border-black/15 px-2 py-1 rounded text-sm" /></td>
                  <td className="p-3"><input type="color" value={st.color || "#FF5E00"} onChange={(e) => updState(uf, { color: e.target.value })} className="w-16 h-8 border border-black/15 rounded" /></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
